<template>
  <v-row>
    <v-col
      ><v-select
        dense
        label="State"
        class="white"
        :items="state"
        item-text="name"
        outlined
        v-model="item"
        item-value="value"
      ></v-select
    ></v-col>
  </v-row>
</template>

<script>
export default {
  props: ["callbackSelect"],
  data: () => ({
    state: [],
    id: null,
    item: "",
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
  }),
  watch: {
    item: function (val) {
      this.item = val;
      this.callbackSelect(val);
    },
  },
  created() {
    this.api.method = "get";
    this.api.url = `${this.$api.servers.sso}/api/v1/en/data/state`;
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.state = [
        { name: "All", value: "all" },
        ...resp,
        { name: "No Value", value: "no-value" },
      ];

      this.item = this.state[0].value
    };
  },
  mounted() {
    this.$api.fetch(this.api);
  },
};
</script>

<style>
</style>